export enum EValuationTrap {
  cpd = 'cpd',
  cpl = 'cpl',
}
